import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Screen from '../../components/common/Screen';
import Title from '../../components/common/Title';
import Button from '../../components/elements/Button';
import Toast from '../../components/forms/Toast';
import Icon from '../../components/common/Icon';
import { apiRequest } from '../../utils';

// Password reset for a logged-in user. Rather than an in-place form, we email a
// secure reset link to the account address (same flow as the public
// forgot-password), so a compromised session can't silently set a new password.
const ChangePassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [error, setError] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const requestReset = async () => {
    setSubmitting(true);
    try {
      await apiRequest('POST', '/request-password-reset');
      setError(null);
      setSent(true);
    } catch (err) {
      setError(err.message);
      setShowToast(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Screen color="white" p="3">
      <div className="top">
        <Title>{t('changePassword')}</Title>

        {sent ? (
          <div className="text-center mt-4">
            <div style={{ fontSize: '2.5rem' }} className="mb-2">
              <Icon name="paper-plane" theme="primary" />
            </div>
            <p className="fw-bold">{t('resetLinkSent')}</p>
          </div>
        ) : (
          <>
            <p className="text-secondary mb-4">{t('changePasswordSubtitle')}</p>
            <Button onClick={requestReset} disabled={submitting}>
              {submitting ? '…' : t('sendResetLink')}
            </Button>
          </>
        )}

        <Toast showToast={showToast} setShowToast={setShowToast} message={t(error)} />
      </div>

      <div className="bottom">
        <div className="px-3">
          <hr className="mb-3" />
          <Button theme="light" onClick={() => navigate('/profile')} className="mb-3">
            {t('done')}
          </Button>
        </div>
      </div>
    </Screen>
  );
};

export default ChangePassword;
